import { fetchSoilData } from "./soilService";
import { fetchWeatherData } from "./weatherService";

/**
 * Get bounding box grid points for sampling
 */
export function getBoundingBoxGrid(bounds, gridSize = 3) {
  const northWest = bounds.getNorthWest();
  const southEast = bounds.getSouthEast();

  const minLat = southEast.lat;
  const maxLat = northWest.lat;
  const minLon = northWest.lng;
  const maxLon = southEast.lng;

  console.log("=== Area Bounding Box Coordinates ===");
  console.log(`North: ${maxLat.toFixed(6)}`);
  console.log(`South: ${minLat.toFixed(6)}`);
  console.log(`East: ${maxLon.toFixed(6)}`);
  console.log(`West: ${minLon.toFixed(6)}`);
  console.log("=====================================");

  const gridPoints = [];
  for (let i = 0; i < gridSize; i++) {
    for (let j = 0; j < gridSize; j++) {
      const lat = minLat + ((maxLat - minLat) * i) / (gridSize - 1);
      const lon = minLon + ((maxLon - minLon) * j) / (gridSize - 1);
      gridPoints.push({ lat, lon });
    }
  }

  return gridPoints;
}

/**
 * Collect comprehensive area data (soil + weather)
 */
export async function collectAreaData(layer, gridSize = 2) {
  const bounds = layer.getBounds();
  const gridPoints = getBoundingBoxGrid(bounds, gridSize);

  const northWest = bounds.getNorthWest();
  const southEast = bounds.getSouthEast();
  const boundingBoxCoords = {
    north: northWest.lat,
    south: southEast.lat,
    east: southEast.lng,
    west: northWest.lng,
  };

  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(endDate.getDate() - 30);

  const formatDate = (date) => {
    return date.toISOString().slice(0, 10).replace(/-/g, "");
  };

  const start = formatDate(startDate);
  const end = formatDate(endDate);

  console.log(
    `Collecting data for ${gridPoints.length} grid points within drawn area...`
  );
  console.log(
    `Area bounds: North ${boundingBoxCoords.north.toFixed(
      6
    )}, South ${boundingBoxCoords.south.toFixed(
      6
    )}, East ${boundingBoxCoords.east.toFixed(
      6
    )}, West ${boundingBoxCoords.west.toFixed(6)}`
  );

  const collectionPromises = gridPoints.map(async (point, idx) => {
    console.log(
      `Fetching data for point ${idx + 1}/${
        gridPoints.length
      }: (${point.lat.toFixed(6)}, ${point.lon.toFixed(6)})`
    );

    const [soilData, weatherData] = await Promise.all([
      fetchSoilData(point.lat, point.lon),
      fetchWeatherData(point.lat, point.lon, start, end),
    ]);

    return {
      point_index: idx + 1,
      coordinates: point,
      soil_data: soilData,
      weather_data: weatherData,
    };
  });

  const results = await Promise.all(collectionPromises);

  return {
    bounding_box: boundingBoxCoords,
    sampling_grid_size: gridSize,
    total_points: gridPoints.length,
    time_period: { start, end },
    collection_timestamp: new Date().toISOString(),
    sampling_points: results,
  };
}
